export default "__VITE_ASSET__ClExd$xK__"